export const prooV = "https://imda-app.proov.io";
export const domainProject = "https://dtlehta1thuw9.cloudfront.net/projectmgmt/api";
export const testcase = "https://dtlehta1thuw9.cloudfront.net/testcasemgmt/api";
export const jmxView = "https://dtlehta1thuw9.cloudfront.net/testcasemgmt/api/attachment/views/";
export const jmxDownload = "https://dtlehta1thuw9.cloudfront.net/testcasemgmt/api/attachment/downloads/";
export const stapiURL = "https://imda-app.proov.io";
export const REPORT_URL = "https://dtlehta1thuw9.cloudfront.net/quantifyreport";
export const LOG_URL = "https://dtlehta1thuw9.cloudfront.net/management/api/v1/download/";
export const JTL_URL = "https://dtlehta1thuw9.cloudfront.net/management/api/v1/downloadJtl/"
export const StrapiURL = "https://djnv5g5nduiwq.cloudfront.net/1platformcms"